module.exports = __webpack_public_path__ + "static/media/helpIcon.ac4f5834.svg";